import {
  createReqConsts,
  createActions,
  createReqReducer,
  createReqWatcher,
  initialState as requestInitialState,
} from '../../../utils/redux';

export const consts = createReqConsts('profile', 'historic-measurements');
export const actions = createActions(consts);
export const watcher = createReqWatcher(consts, actions, {
  endpoint: 'fitness_tracking',
  type: 'get',
  slug: [
    'historic_measurements',
    {
      type: 'payload.query',
      queryParameter: 'type',
      selector: 'typeMeasurements',
    },
    {
      type: 'payload.query',
      queryParameter: 'period_start_date',
      selector: 'periodStartDate',
    },
    {
      type: 'payload.query',
      queryParameter: 'user_id',
      selector: 'userId',
    },
  ],
});

const initialState = {
  ...requestInitialState,
  list: [],
};

const requestReducer = createReqReducer(consts);

export default (state = initialState, action) => {
  const { payload, type } = action;

  switch (type) {
    case consts.SUCCEED: {
      return {
        ...state,
        succeed: true,
        sending: false,
        list:
          state.list && state.list.length !== 0
            ? state.list.concat(payload)
            : payload,
      };
    }

    default:
      return requestReducer(state, action);
  }
};



// WEBPACK FOOTER //
// ./src/redux/profiles/patientHealthboard/historic-measurements-req.js